export default __webpack_public_path__ + "static/media/toki.485dee1f.png";